import ContentsTypes from "@shared/enums/contentsTypes";
import PresentationBlockPreview from "@project/components/PresentationBlock/PresentationBlockPreview";
import ContentsCustomTypes from "@project/enums/contentsCustomTypes.enum";
export const ColumnWithIconItem = {
    label: "Item colonne avec icône",
    key: "items",
    type: ContentsCustomTypes.COLUMN_WITH_ICON_ITEM,
    children: [
        {
            label: "Icône",
            key: "icon",
            type: ContentsTypes.ICON,
            value: "",
        },
        {
            label: "Titre",
            key: "title",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Description",
            key: "description",
            type: ContentsTypes.INPUT,
            value: "",
        },
    ],
};
export const ColumnsWithIcon = {
    label: "Liste en colonnes avec icônes",
    type: ContentsCustomTypes.COLUMNS_WITH_ICON,
    Preview: PresentationBlockPreview,
    icon: "columns",
    editionModal: true,
    editionModalPosition: "top",
    children: [
        {
            key: "dynamicList",
            type: ContentsTypes.DYNAMIC_LIST,
            value: "",
            children: [
                {
                    key: "contentType",
                    children: [ColumnWithIconItem],
                    value: ContentsCustomTypes.COLUMN_WITH_ICON_ITEM,
                },
            ],
        },
    ],
};
